import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import StatsCard from '../../../../components/user/general/successcard/SuccessCard';
import { FaWrench, FaAward, FaRocket, FaUsers } from 'react-icons/fa';
import '../../../../assets/css/user/maintainance/qualitystandard/QualityStandard.css';

const QualityStandard = () => {
  const statistics = [
    {
      id: 1,
      icon: <FaWrench />,
      number: 525,
      label: 'Equipment Successfully Maintained & Serviced'
    },
    {
      id: 2,
      icon: <FaAward />,
      number: 27,
      label: 'Years of Trusted Agricultural Service'
    },
    {
      id: 3,
      icon: <FaRocket />,
      number: 112,
        label: 'Modern Farming Equipment Available'
    },
    {
      id: 4,
      icon: <FaUsers />,
      number: 1524,
      label: 'Satisfied Farmers & Clients'
    }
  ];

  return (
    <section className="stats-main-section">
      <Container>
        <Row className="align-items-stretch">
          {/* Left Yellow Box */}
          <Col lg={6} md={12} className="stats-left-col">
            <div className="stats-yellow-box">
              <h2 className="stats-main-heading">
                5+ YEARS OF TRUSTED AGRICULTURAL SERVICE
              </h2>
              <p className="stats-description">
  SmartAgri Rent is dedicated to providing reliable agricultural equipment rental and maintenance services. We focus on modern farming solutions, quality machinery, and timely support to help farmers increase productivity and reduce operational challenges.
</p>
            </div>
          </Col>

          {/* Right Stats Grid */}
          <Col lg={6} md={12} className="stats-right-col">
            <Row className="stats-grid">
              {statistics.map((stat) => (
                <Col 
                  key={stat.id} 
                  xs={6} 
                  className="stats-card-col"
                >
                  <StatsCard stat={stat} />
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default QualityStandard;